/* eslint-disable */

export enum BhImageType {
	Product = 0,
	Category = 1,
	Banner = 2,
	CmsImage = 3,
	Video = 4,
	
}
